export enum eChatLeadsTabs {
  ALL = 'all',
  ASSIGNED_TO_ME = 'assigned_to_me',
  ARCHIVED = 'archived',
  ACTIVE = 'active',
  UNREAD = 'unread',
  /** INT-1500 U14: "No entregados", behind chat_undelivered-list. */
  UNDELIVERED = 'undelivered',
}

export enum eLeadbotState {
  NONE = 'NONE',
  SESSION_FINISHED = 'SESSION_FINISHED',
  SESSION_ACTIVE = 'SESSION_ACTIVE',
  USER_INTERACTION = 'USER_INTERACTION',
  SESSION_REACTIVATED = 'SESSION_REACTIVATED',
}
